import React from 'react';

import PropTypes from 'prop-types';

import { Spinner } from '../../../../../shared/components/Spinner';
import { messageShape } from '../../../../../shared/types';
import Message from './Message';

import styles from './MessageList.module.scss';

const MessageList = ({ isLoading, messages }) => {
  if (isLoading) {
    return <Spinner />;
  }

  return (
    <ol className={styles.messages}>
      {messages.map((message) => (
        <li key={message.id}>
          <Message content={message.content} sender={message.sender} />
        </li>
      ))}
    </ol>
  );
};

MessageList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(messageShape).isRequired,
};

export default MessageList;
